var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container",class:{'spinner-container--fullscreen': _vm.fullscreen}},[_c('div',{staticClass:"circle-path"}),_vm._v(" "),_c('h1',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }